import request from '@/utils/request'

//合同类首页-查询资产合同
export function zchtSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//合同类首页-查询对外投资合同
export function dwtzhtSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//合同类首页-查询工程建设合同
export function gcjshtSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//资产合同列表页
export function zchtListSearch(url,obj){
  return request({
      url,
      methods:'get',
      params:obj
  })
} 

//对外投资合同列表页
export function dwtzhtListSearch(url,obj){
  return request({
      url,
      methods:'get',
      params:obj
  })
} 

//对外工程建设合同
export function gcjshtListSearch(url,obj){
  return request({
      url,
      methods:'get',
      params:obj
  })
} 